/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react'
import { Form, Field } from 'formik'
import {
    Row,
    Col,
    Tooltip,
    Menu,
    Dropdown,
    Icon,
    Tag,
    Input,
    Button,
    Progress,
    Avatar,
    Popover,
    Divider,
} from 'antd'
import { connect } from 'react-redux'

import {
    AntDatePicker,
    AntSelect,
    AntTextArea,
    AntProgress,
} from '../../../../../componentIsoMophic/ScrumBoard/AntFields'
import { dateFormat } from '../../../../../componentIsoMophic/ScrumBoard/FieldFormats'
import CreateTaskHeader from '../CreateTaskHeader/CreateTaskHeader'
import HeadingWithIcon from '../../../../../componentIsoMophic/ScrumBoard/HeadingWithIcon/HeadingWithIcon'
import TitleIcon from '../../../../assets/images/icon/05-icon.svg'
import DescriptionIcon from '../../../../assets/images/icon/06-icon.svg'
import AttachmentIcon from '../../../../assets/images/icon/01-icon.svg'
import { IconSvg } from '../../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import OrgAction from '../../../../../redux/organization/actions'
import EventAction from '../../../../../redux/event/actions'

import scrumBoardActions from '../../../../../redux/scrumBoard/actions'
import mediaAction from '../../../../../redux/qbmedia/actions'
import Modal from '../../../../..//components/feedback/modal'
import MediaManagementScreen from '../../../../MediaManagement/index'
import { AttachmentWrapper } from '../TaskCreateOrUpdate.style'
import { FaPlusCircle } from 'react-icons/fa'
import ObjectsScreen from '../../../../ObjectsManagement/index'
import objectAction from '../../../../../redux/object/actions'
import SelectMediaComponent from '../../../../../components/select_medias'
import SelectObjectComponent from '../../../../../components/select_objects'
import SelectEventComponent from '../../../../../components/select_events'
import { MdAssignment, MdViewModule } from 'react-icons/md'
import { IoIosPaperPlane } from 'react-icons/io'
import { FaCalendarCheck } from 'react-icons/fa'
import defaultImgEvent from '../../../../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../../../../resource/image/objectDefault.png'

const ButtonGroup = Button.Group
let temp = 1
const { Search } = Input

const RenderTaskForm = ({
    handleSubmit,
    values,
    submitCount,
    onCancel,
    onDelete,
    onEditCancel,
    updateListOrgQuery,
    listOrgUpdate,
    updateHashTag,
    listUpdateHashTag,
    ListCurrentMedia,
    getListMediaQueryById,
    getListMediaQueryByIdDone,
    showModalMedia,
    VisibleModalMedia,
    ListCurrentObject,
    showModalObject,
    VisibleModalObject,
    getListCurrentEvent,
    ListCurrentEvent,
    updateListCurrentEvent,
    getListEvent,
    events,
    getListObjectQueryById,
    totalEvent,
    loadListOrganization,
    organizations,
    getListOrgQueryById,
    applyToMedia,
    applyToCurrentObject,
    VisibleModalEvent,
    visibleModalEvent,
    getListObjectQueryById_done,
    getListCurrentEventDone,
    getListOrgQueryByIdDone,
    searchUserByText,
    listUserSearchByText,
    updateCurrentUserPickup,
    currentUserPickUp,
    getListCurrentUser,
    lstCurrentUser,
    getListCurrentUserDone,
}) => {
    useEffect(() => {
        console.log('value create task', values)
        // loadListOrganization(0)
        getListEvent(1, 10, 0)
        if (values.lst_organ_receive_id) {
            console.log('get list org')
            getListOrgQueryById(values.lst_organ_receive_id.toString())
        }
        if (values.lst_media) {
            getListMediaQueryById(values.lst_media.toString())
        }
        if (values.lst_event_id) {
            getListCurrentEvent(values.lst_event_id.toString())
        }
        if (values.lst_object_id) {
            getListObjectQueryById(values.lst_object_id.toString())
        }
        if (values.lst_uid_receive.length > 0) {
            getListCurrentUser(values.lst_uid_receive)
        }

        searchUserByText('')
        return () => {
            getListMediaQueryByIdDone([])
            getListObjectQueryById_done([])
            getListCurrentEventDone([])
            getListOrgQueryByIdDone([])
            updateCurrentUserPickup([])
            getListCurrentUserDone([])
            console.log('reset data update task')
        }
    }, [getListMediaQueryById, getListMediaQueryByIdDone, getListEvent])
    console.log('data organizations', organizations)
    const [visible, setvisible] = useState(false)
    const [hashtag, sethashtag] = useState('')
    const [update, setupdate] = useState()
    console.log('lstCurrentUser', lstCurrentUser)
    const form = useRef(null)

    const getListOrgCanAdd = () => {
        if (organizations && values.currentListOrg) {
            return organizations.filter(org => {
                const isInArray = values.currentListOrg.find(crr => {
                    return crr.oid === org.oid
                })
                const isInArray1 = listOrgUpdate.find(update => {
                    return update.oid === org.oid
                })
                if (isInArray || isInArray1) {
                    return false
                } else {
                    return true
                }
            })
        } else {
            return organizations
        }
    }

    const menu = (
        <Menu>
            {getListOrgCanAdd() &&
                getListOrgCanAdd().map(org => (
                    <Menu.Item
                        key={org.oid}
                        onClick={() => updateListOrgQuery(org)}
                    >
                        <IconSvg
                            src={org.ext_data.avatarOrgani}
                            padding={'0'}
                            radius={'10% 30% 25%'}
                        />
                        {org.name}
                    </Menu.Item>
                ))}
        </Menu>
    )

    const handleAddTag = () => {
        setvisible(false)
        if (hashtag.trim() !== '') {
            updateHashTag(hashtag)
        }
        sethashtag('')
    }
    const _userSelectMedia = medias => {
        console.log('medias : ', medias)
        showModalMedia(false)
        applyToMedia([])
        applyToMedia(medias)
    }
    const menuHashtag = (
        <Menu>
            <Menu.Item>
                <Input
                    placeholder="Nhập hashtag"
                    maxLength={25}
                    value={hashtag}
                    style={{ width: 200 }}
                    onChange={e => sethashtag(e.target.value)}
                />
                <Button
                    type="primary"
                    onClick={handleAddTag}
                    style={{ marginLeft: 10 }}
                >
                    Thêm
                </Button>
                <Button
                    type="primary"
                    onClick={() => {
                        setvisible(false)
                        sethashtag('')
                    }}
                    style={{ marginLeft: 10 }}
                >
                    Huỷ
                </Button>
            </Menu.Item>
        </Menu>
    )
    const _userSelectEvent = events => {
        visibleModalEvent(false)
        updateListCurrentEvent([])
        updateListCurrentEvent(events)
    }
    const _userSelectObject = objects => {
        showModalObject(false)
        applyToCurrentObject([])
        applyToCurrentObject(objects)
    }
    const getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    const getColorTag = () => {
        const color = [
            'magenta',
            'red',
            'volcano',
            'orange',
            'gold',
            'lime',
            'green',
            'cyan',
            'blue',
            'geekblue',
            'purple',
        ]
        const index = getRandomInt(color.length)

        return color[index]
    }
    console.log('listOrgUpdate', listOrgUpdate)
    const handleVisibleChange = visible => {
        setvisible(visible)
        sethashtag('')
    }
    const default_avatar = require('../../../../../resource/image/defaultUser.png')
    const getListUserCanAdd = () => {
        if (listUserSearchByText && values.lst_uid_receive) {
            return listUserSearchByText.filter(user => {
                const isInArray = currentUserPickUp.find(crr => {
                    return crr.uid === user.uid
                })
                const isInArray1 = values.lst_uid_receive.find(uidReceive => {
                    return uidReceive === user.uid
                })
                if (isInArray || isInArray1) {
                    return false
                } else {
                    return true
                }
            })
        } else {
            return listUserSearchByText
        }
    }
    const contentAddUserJoin = (
        <div>
            <Search
                placeholder="Nhập để tìm kiếm"
                onChange={value => searchUserByText(value.target.value)}
                style={{ width: 200, marginLeft: 15 }}
            />
            <Divider style={{ margin: 7 }} />

            {getListUserCanAdd().length > 0 &&
                getListUserCanAdd().map(user => (
                    <Button
                        style={{ display: 'flex', flexDirection: 'row' }}
                        type="link"
                        onClick={() => {
                            updateCurrentUserPickup(user)
                        }}
                    >
                        <IconSvg
                            src={
                                user.avatar === ''
                                    ? default_avatar
                                    : user.avatar
                            }
                            padding={'0'}
                            radius={'25% 25% 25% 25%'}
                        />
                        {user.display_name}
                    </Button>
                ))}
            {listUserSearchByText.length === 0 && <div>Không có dữ liệu</div>}
        </div>
    )

    return (
        <Form ref={form} onSubmit={handleSubmit}>
            <CreateTaskHeader
                values={values}
                onCancel={onCancel}
                onDelete={onDelete}
                onEditCancel={onEditCancel}
            />
            <Field
                component={AntTextArea}
                name="title"
                type="text"
                tasklabel={
                    <HeadingWithIcon
                        heading="Tên nhiệm vụ"
                        iconSrc={TitleIcon}
                    />
                }
                placeholder="Thêm tên nhiệm vụ"
                submitCount={submitCount}
                hasFeedback
                rows={3}
                formitem={{
                    colon: false,
                }}
            />
            <Row gutter={16}>
                <Col md={6}>
                    <HeadingWithIcon heading="Đơn vị tham gia" />
                    <p>
                        {values.type === 'require' &&
                            values.currentListOrg &&
                            values.currentListOrg.map(org => (
                                <Tooltip
                                    title={org.name}
                                    placement="bottom"
                                    key={Tooltip}
                                >
                                    {values.status === 0 && (
                                        <Popover
                                            content={
                                                <a
                                                    onClick={() => {
                                                        for (
                                                            let i = 0;
                                                            i <
                                                            values
                                                                .currentListOrg
                                                                .length;
                                                            i++
                                                        ) {
                                                            if (
                                                                values
                                                                    .currentListOrg[
                                                                    i
                                                                ].oid ===
                                                                org.oid
                                                            ) {
                                                                values.currentListOrg.splice(
                                                                    i,
                                                                    1
                                                                )
                                                                values.lst_organ_receive_id.splice(
                                                                    i,
                                                                    1
                                                                )
                                                                setupdate({})
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Xoá đơn vị này
                                                </a>
                                            }
                                            trigger="click"
                                        >
                                            <IconSvg
                                                src={org.ext_data.avatarOrgani}
                                                padding={'0'}
                                                radius={'10% 30% 25%'}
                                            />
                                        </Popover>
                                    )}
                                    {values.status !== 0 && (
                                        <IconSvg
                                            src={org.ext_data.avatarOrgani}
                                            padding={'0'}
                                            radius={'10% 30% 25%'}
                                        />
                                    )}
                                </Tooltip>
                            ))}
                        {listOrgUpdate &&
                            listOrgUpdate.map(orgUpdate => (
                                <Tooltip
                                    title={orgUpdate.name}
                                    placement="bottom"
                                    key={Tooltip}
                                >
                                    <IconSvg
                                        src={orgUpdate.ext_data.avatarOrgani}
                                        padding={'0'}
                                        radius={'10% 30% 25%'}
                                        style={{
                                            marginTop: 5,
                                        }}
                                    />
                                </Tooltip>
                            ))}
                        {values.status === 0 && (
                            <Tooltip
                                title="Thêm đơn vị tham gia"
                                placement="bottom"
                            >
                                <Dropdown overlay={menu} trigger={['click']}>
                                    <FaPlusCircle
                                        style={{
                                            width: 30,
                                            height: 30,
                                            marginLeft: 10,
                                            marginTop: 5,
                                        }}
                                        color="#4d95be"
                                    />
                                </Dropdown>
                            </Tooltip>
                        )}
                    </p>
                </Col>
                <Col md={6}>
                    <HeadingWithIcon heading="Cá nhân tham gia" />
                    <p>
                        {values.type === 'require' &&
                            lstCurrentUser &&
                            lstCurrentUser.map(user => (
                                <Tooltip
                                    title={user.display_name}
                                    placement="bottom"
                                    key={Tooltip}
                                >
                                    {values.status === 0 && (
                                        <Popover
                                            content={
                                                <a
                                                    onClick={() => {
                                                        for (
                                                            let i = 0;
                                                            i <
                                                            lstCurrentUser.length;
                                                            i++
                                                        ) {
                                                            if (
                                                                lstCurrentUser[
                                                                    i
                                                                ].uid ===
                                                                user.uid
                                                            ) {
                                                                let lst = lstCurrentUser
                                                                lst.splice(i, 1)
                                                                values.lst_uid_receive.splice(
                                                                    i,
                                                                    1
                                                                )
                                                                setupdate({})
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Xoá cá nhân này
                                                </a>
                                            }
                                            trigger="click"
                                        >
                                            <IconSvg
                                                src={
                                                    user.avatar === ''
                                                        ? default_avatar
                                                        : user.avatar
                                                }
                                                padding={'0'}
                                                radius={'10% 30% 25%'}
                                            />
                                        </Popover>
                                    )}
                                    {values.status !== 0 && (
                                        <IconSvg
                                            src={
                                                user.avatar === ''
                                                    ? default_avatar
                                                    : user.avatar
                                            }
                                            padding={'0'}
                                            radius={'10% 30% 25%'}
                                        />
                                    )}
                                </Tooltip>
                            ))}
                    </p>
                    {currentUserPickUp.map(user => (
                        <Tooltip
                            title={user.display_name}
                            placement="bottom"
                            key={user.uid}
                        >
                            <IconSvg
                                src={
                                    user.avatar === ''
                                        ? default_avatar
                                        : user.avatar
                                }
                                padding={'0'}
                                radius={'10% 30% 25%'}
                                style={{
                                    marginTop: 5,
                                }}
                            />
                        </Tooltip>
                    ))}
                    {values.status === 0 && (
                        <Tooltip
                            title="Thêm cá nhân tham gia"
                            placement="bottom"
                        >
                            <Popover
                                placement="right"
                                content={contentAddUserJoin}
                                trigger="click"
                            >
                                <FaPlusCircle
                                    style={{
                                        width: 30,
                                        height: 30,
                                        marginLeft: 10,
                                    }}
                                    color="#4d95be"
                                />
                            </Popover>
                        </Tooltip>
                    )}
                </Col>
                <Col md={6}>
                    <HeadingWithIcon heading="HashTag" />
                    <p>
                        {values.labels.map(label => (
                            <Tooltip
                                title={label}
                                placement="bottom"
                                key={label}
                            >
                                <Popover
                                    content={
                                        <a
                                            onClick={() => {
                                                for (
                                                    let i = 0;
                                                    i < values.labels.length;
                                                    i++
                                                ) {
                                                    if (
                                                        values.labels[i] ===
                                                        label
                                                    ) {
                                                        values.labels.splice(
                                                            i,
                                                            1
                                                        )
                                                        setupdate({})
                                                    }
                                                }
                                                // this.setState(
                                                //     {
                                                //         visibleDelete: false,
                                                //     }
                                                // )
                                            }}
                                        >
                                            Xoá hashtag này
                                        </a>
                                    }
                                    trigger="click"
                                >
                                    <Tag color={getColorTag()}>{label}</Tag>
                                </Popover>
                            </Tooltip>
                        ))}
                        {listUpdateHashTag.map(tag => (
                            <Tooltip title={tag} placement="bottom" key={tag}>
                                <Popover
                                    content={
                                        <a
                                            onClick={() => {
                                                for (
                                                    let i = 0;
                                                    i <
                                                    listUpdateHashTag.length;
                                                    i++
                                                ) {
                                                    if (
                                                        listUpdateHashTag[i] ===
                                                        tag
                                                    ) {
                                                        listUpdateHashTag.splice(
                                                            i,
                                                            1
                                                        )
                                                        setupdate({})
                                                    }
                                                }
                                            }}
                                        >
                                            Xoá hashtag này
                                        </a>
                                    }
                                    trigger="click"
                                >
                                    <Tag color={getColorTag()}>{tag}</Tag>
                                </Popover>
                            </Tooltip>
                        ))}

                        <Tooltip title="Thêm Hashtag" placement="bottom">
                            <Dropdown
                                overlay={menuHashtag}
                                trigger={['click']}
                                visible={visible}
                                onVisibleChange={handleVisibleChange}
                            >
                                <FaPlusCircle
                                    style={{
                                        width: 30,
                                        height: 30,
                                        marginLeft: 10,
                                        marginTop: 5,
                                    }}
                                    color="#4d95be"
                                    onClick={() => setvisible(true)}
                                />
                            </Dropdown>
                        </Tooltip>
                    </p>
                </Col>
                <Col md={6}>
                    <Field
                        component={AntDatePicker}
                        name="due_date"
                        tasklabel={<HeadingWithIcon heading="Ngày kết thúc" />}
                        defaultValue={values.due_date}
                        format={dateFormat}
                        submitCount={submitCount}
                        hasFeedback
                        size="large"
                    />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col md={8}>
                    <HeadingWithIcon
                        icon={
                            <MdAssignment
                                style={{
                                    paddingRight: 4,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Tài liệu liên quan `}
                    />
                    {ListCurrentMedia.map(media => (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <Button
                                type="link"
                                // href={media.url}
                                target="_blank"
                                onClick={() => {
                                    window.open(media.url, '_blank')
                                }}
                                block={false}
                                style={{ paddingLeft: 5 }}
                            >
                                {media.name}
                            </Button>
                            <Icon
                                style={{ cursor: 'pointer' }}
                                type="close"
                                onClick={() => {
                                    for (
                                        let i = 0;
                                        i < ListCurrentMedia.length;
                                        i++
                                    ) {
                                        if (
                                            ListCurrentMedia[i].media_id ===
                                            media.media_id
                                        ) {
                                            ListCurrentMedia.splice(i, 1)
                                            setupdate({})
                                        }
                                    }
                                }}
                            />
                        </div>
                    ))}
                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => showModalMedia(true)}
                        style={{ marginTop: 10, width: 150 }}
                    >
                        Chọn tài liệu
                    </Button>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <IoIosPaperPlane
                                style={{
                                    paddingRight: 4,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Đối tượng liên quan `}
                    />
                    <div>
                        {ListCurrentObject.map(object => (
                            <Tooltip
                                title={object.name}
                                placement="bottom"
                                key={object}
                            >
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`/app/qbobjects/${object.object_id}`}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={
                                            object.avatar === ''
                                                ? objectDefault
                                                : object.avatar
                                        }
                                        style={{ margin: 10 }}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                    </div>
                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => showModalObject(true)}
                        style={{ marginTop: 10, width: 150 }}
                    >
                        Chọn đối tượng
                    </Button>
                </Col>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <FaCalendarCheck
                                style={{
                                    paddingRight: 4,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Sự kiện liên quan `}
                    />
                    <div>
                        {ListCurrentEvent.map(event => (
                            <Tooltip
                                title={event.name}
                                placement="bottom"
                                key={event}
                            >
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`/app/qbevents/${event.event_id}`}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={
                                            event.avatar === ''
                                                ? defaultImgEvent
                                                : event.avatar
                                        }
                                        style={{ margin: 10 }}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                    </div>

                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => {
                            visibleModalEvent(true)
                        }}
                        style={{ marginTop: 10, width: 150 }}
                    >
                        Chọn sự kiện
                    </Button>
                </Col>
            </Row>

            <Field
                component={AntProgress}
                name="process"
                type="text"
                tasklabel={
                    <HeadingWithIcon
                        heading="Tiến độ hoàn thành"
                        icon={
                            <MdViewModule
                                style={{
                                    paddingRight: 4,
                                    height: 18,
                                    width: 18,
                                }}
                            />
                        }
                    />
                }
                defaultValue={values.process}
                submitCount={submitCount}
                hasFeedback
                formitem={{
                    colon: false,
                }}
            />

            <Row gutter={16}>
                {/* <Col span={8}>
                    <Field
                        component={AntSelect}
                        mode="multiple"
                        name="assignees"
                        tasklabel={<HeadingWithIcon heading="Assign Members" />}
                        defaultValue={values.assignees}
                        selectOptions={values.selectAssignees}
                        submitCount={submitCount}
                        tokenSeparators={[',']}
                        hasFeedback
                        size="large"
                    />
                </Col> */}
                {/* <Col span={8}>
                    <Field
                        component={AntSelect}
                        mode="multiple"
                        name="labels"
                        tasklabel={<HeadingWithIcon heading="Labels" />}
                        defaultValue={values.labels}
                        selectOptions={values.selectOptions}
                        submitCount={submitCount}
                        tokenSeparators={[',']}
                        hasFeedback
                        size="large"
                    />
                </Col> */}
            </Row>

            <Field
                component={AntTextArea}
                name="description"
                type="text"
                placeholder="Một số yêu cầu nhiệm vụ"
                tasklabel={
                    <HeadingWithIcon
                        heading="Yêu cầu *"
                        iconSrc={DescriptionIcon}
                    />
                }
                submitCount={submitCount}
                hasFeedback
                rows={10}
                formitem={{
                    colon: false,
                }}
            />

            {VisibleModalMedia && (
                <Modal
                    visible={true}
                    title="Lựa chọn tài liệu"
                    onOk={() => showModalMedia(false)}
                    onCancel={() => showModalMedia(false)}
                    centered
                    width={900}
                    footer={null}
                >
                    <SelectMediaComponent
                        onSuccess={medias => _userSelectMedia(medias)}
                        onCancel={() => showModalMedia(false)}
                        initMedia={ListCurrentMedia}
                    />
                </Modal>
            )}
            {VisibleModalEvent && (
                <Modal
                    visible={true}
                    title="Sự kiện liên quan"
                    onOk={() => visibleModalEvent(false)}
                    onCancel={() => visibleModalEvent(false)}
                    width={900}
                    centered
                    footer={[]}
                >
                    <SelectEventComponent
                        onSuccess={events => _userSelectEvent(events)}
                        onCancel={() => visibleModalEvent(false)}
                        initEvent={ListCurrentEvent}
                    />
                </Modal>
            )}
            {VisibleModalObject && (
                <Modal
                    visible={true}
                    title="Lựa chọn đối tượng"
                    onOk={() => showModalObject(false)}
                    onCancel={() => showModalObject(false)}
                    width={900}
                    centered
                    footer={[]}
                >
                    <SelectObjectComponent
                        onSuccess={objects => _userSelectObject(objects)}
                        onCancel={() => showModalObject(false)}
                        initObject={ListCurrentObject}
                    />
                </Modal>
            )}
        </Form>
    )
}
export default connect(
    (state, ownProps) => {
        console.log('state.qbmedia', state.qbmedia.currentListMedia)
        return {
            listOrgUpdate: state.organization.listOrgUpdate,
            listUpdateHashTag: state.scrumBoard.listUpdateHashTag,
            ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
            VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
            ListCurrentObject: state.scrumBoard.ListCurrentObject,
            VisibleModalObject: state.scrumBoard.VisibleModalObject,
            ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
            events: state.eventReducer.events,
            totalEvent: state.eventReducer.totalEvent,
            organizations: state.organization.organizations,
            VisibleModalEvent: state.scrumBoard.VisibleModalEvent,
            listUserSearchByText: state.scrumBoard.listUserSearchByText,
            currentUserPickUp: state.scrumBoard.currentUserPickUp,
            lstCurrentUser: state.scrumBoard.lstCurrentUser,
        }
    },
    {
        ...OrgAction.action,
        ...scrumBoardActions,
        ...mediaAction.action,
        ...EventAction.action,
        ...objectAction.action,
    }
)(RenderTaskForm)
